import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { Breadcrumb } from "./Breadcrumb";
import { HiOutlineUserCircle } from "react-icons/hi";
import { HiOutlineBars3 } from "react-icons/hi2";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Tooltip from "@mui/material/Tooltip";
import { UserProfile } from "./UserProfile";

export default function Sidebar({ links, setLinks }) {
  const isDemo = process.env.REACT_APP_BASENAME === "/demo";
  const [mobileOpen, setMobileOpen] = useState(true);
  const [fade, setFade] = useState(false);
  const [screenSize, getDimension] = useState(window.innerWidth);

  const [pathname, setPathname] = useState("");
  const [link, setLink] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (event) => {
    if (event.currentTarget.scrollTop > 24) {
      setFade(false);
    } else {
      setFade(true);
    }
  };

  let head = document.getElementById("sidebar");
  head?.addEventListener("touchstart", handleTouchStart, false);
  head?.addEventListener("touchmove", handleTouchMove, false);

  var xDown = null;
  var yDown = null;

  function getTouches(evt) {
    return (
      evt.touches || // browser API
      evt.originalEvent.touches
    ); // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;
    //The Math.abs() static method returns the absolute value of a number
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* right swipe */
      } else {
        /* left swipe */
      }
    } else {
      if (yDiff > 0) {
        /* down swipe */
        setMobileOpen(true);
      } else {
        /* up swipe */
        setMobileOpen(false);
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  }

  const setDimension = () => {
    getDimension(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);
    return () => {
      window.removeEventListener("resize", setDimension);
      if (screenSize <= "768") {
        setMobileOpen(true);
      } else {
        setMobileOpen(true);
      }
    };
  }, [screenSize]);

  useEffect(() => {
    let pathnameNoBackslash = "";
    let linkBread = "";
    if (location.pathname === "/") {
      pathnameNoBackslash = "Home";
    } else if (location.pathname.includes("Dettaglio")) {
      pathnameNoBackslash = location.pathname.replace("/", "");

      let firstStep = location.pathname.split("Dettaglio");
      linkBread = "Dettaglio " + firstStep[1];
    } else {
      pathnameNoBackslash = location.pathname.replace("/", "");
    }

    setLink(linkBread);
    setPathname(pathnameNoBackslash);
  }, [navigate]);
  return (
    <>
      <div className="flex w-full items-start relative dark:bg-white">
        <ClickAwayListener
          onClickAway={() => {
            if (!mobileOpen && screenSize <= "768") {
              setMobileOpen(true);
            }
          }}
        >
          <div
            id="sidebar"
            className={`md:w-20 md:items-center md:flex md:flex-col md:h-screen md:overflow-y-auto md:p-3 md:sticky md:top-0 w-full absolute p-6 bg-white dark:bg-miller-300 duration-500 transition-all z-50 md:z-10 ${mobileOpen ? "h-[78px]" : ""}`}
          >
            <div className="space-y-3">
              <div
                className="flex md:flex-row flex-row-reverse items-center justify-center md:justify-center"
              >
                <>
                  <img
                    id="logoSidebarCompact"
                    src={
                      localStorage.getItem("theme") === "light"
                        ? require("../assets/images/logo-sm.png")
                        : require("../assets/images/logo-chiaro-sm.png")
                    }
                    className="hidden h-11 w-11 rounded-xl object-contain md:block"
                    alt="Miller"
                  />
                  <div className="flex-1 md:hidden"></div>
                  <div
                    onClick={() => setMobileOpen(!mobileOpen)}
                    className="flex-1 md:hidden absolute top-[100%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-4 py-4 rounded-full dark:bg-miller-300 bg-white z-10"
                  >
                    <img
                      id="logoSidebarMbl"
                      src={
                        localStorage.getItem("theme") === "light"
                          ? require("../assets/images/logo-sm.png")
                          : require("../assets/images/logo-chiaro-sm.png")
                      }
                      className={`w-12 rounded-full mx-auto duration-500 ${!mobileOpen ? "rotate-180" : ""}`}
                    />
                  </div>
                  <div className="flex-1 md:hidden absolute top-[100%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-2 dark:bg-miller-500 bg-miller-200 z-0"></div>
                </>
                <div
                  className={`w-full md:hidden flex items-center justify-end space-x-4 ${
                    !mobileOpen ? "hidden" : "flex"
                  }`}
                >
                  <UserProfile />
                </div>
                <button
                  className={`flex-1 md:hidden ${!mobileOpen ? "hidden" : "block"}`}
                  onClick={() => setMobileOpen(!mobileOpen)}
                >
                  <HiOutlineBars3 className="dark:text-white text-miller-300 text-3xl font-extrabold md:mx-auto" />
                </button>
              </div>

              <div
                className={`${!mobileOpen ? "flex justify-center" : "md:flex hidden"}`}
              >
                <ul className="md:pt-2 pb-4 mb-4 space-y-1 text-sm flex-col">
                  {links
                    ?.filter((el) => el.visibility)
                    .map((el) => {
                      return (
                        <li
                          className="rounded-sm group relative"
                          key={el.id}
                          id={el.id}
                        >
                            <Tooltip title={el.text} placement="right" arrow enterDelay={200}>
                            <a
                              onClick={() => {
                                if (el.func) {
                                  el.func();
                                } else if (el.child?.length > 0) {
                                  let l = [...links];
                                  l.find((o, i) => {
                                    //inizializzo il cerca
                                    if (o.id === el.id) {
                                      //cerco l'id del link selezionato
                                      let newVisibility = { ...l[i] }; //copio i valori dell'oggetto
                                      newVisibility.childVisibility =
                                        !el.childVisibility; //aggiorno la visibilità
                                      l[i] = { ...newVisibility }; //carico i nuovi valori
                                      return true; // stop searching
                                    }
                                  });
                                  setLinks(l);
                                } else {
                                  navigate(el.href);
                                  setMobileOpen(true);
                                }
                              }}
                              className={
                                el.child?.length > 0
                                  ? "flex h-11 w-11 cursor-pointer items-center justify-center rounded-xl border border-miller-200 text-miller-300 transition-colors hover:bg-miller-200 hover:text-white"
                                  : "flex h-11 w-11 cursor-pointer items-center justify-center rounded-xl border border-miller-200 text-miller-300 transition-colors hover:bg-miller-200 hover:text-white"
                              }
                            >
                              {screenSize > "768" ? el.icon : <></>}
                              {el.child?.length > 0 && !mobileOpen && screenSize <= "768" ? (
                                el.childVisibility ? <IoMdArrowDropup className="li-icon" /> : <IoMdArrowDropdown className="li-icon" />
                              ) : <></>}
                            </a>
                            </Tooltip>
                            {el.child?.length > 0 ? (
                              <ul
                                className={`py-1 space-y-2 text-base flex-col  ${
                                  el.childVisibility ? "flex" : "hidden"
                                }`}
                              >
                                {el.child?.map((elSon) => {
                                  return (
                                    <li
                                      className="rounded-sm relative"
                                      key={elSon.id}
                                      id={elSon.id}
                                    >
                                        <Tooltip title={elSon.text} placement="right" arrow enterDelay={200}>
                                        <a
                                          onClick={() => {
                                            if (elSon.func) {
                                              elSon.func();
                                            } else {
                                              navigate(elSon.href);
                                              setMobileOpen(true);
                                            }
                                          }}
                                          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl border border-miller-100 text-miller-300 transition-colors hover:bg-miller-100 hover:text-white"
                                        >
                                          {screenSize > "768" ? (
                                            elSon.icon
                                          ) : (
                                            <></>
                                          )}
                                        </a>
                                        </Tooltip>
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : (
                              <></>
                            )}
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        </ClickAwayListener>
        <div
          id="body"
          onScroll={handleScroll}
          onClick={() => {
            if (screenSize <= "768" && !mobileOpen) {
              setMobileOpen(!mobileOpen);
            }
          }}
          className={` overflow-y-hidden w-full flex flex-wrap justify-start relative z-10 md:mt-0 mt-[80px]`} //md:max-h-[90vh] max-h-[85vh] md:min-h-[90vh] min-h-[85vh]
        >
          <Breadcrumb pathname={pathname} link={link} isDemo={isDemo} />
          <Outlet />
        </div>
      </div>
    </>
  );
}

/* 
linkExample = [
  id: 5,
  href: "/Parcellazione",
  icon: <MdTableChart className="li-icon" />,
  text: "PARCELLAZIONE",
  childVisibility: false,
  child: [
    {
      id: 1,
      href: "/Home",
      icon: <MdHome className="child-li-icon" />,
      text: "Home",
    },
    {
      id: 2,
      href: "/Home",
      icon: <MdHome className="child-li-icon" />,
      text: "Home",
    },
    {
      id: 3,
      href: "/Home",
      icon: <MdHome className="child-li-icon" />,
      text: "Home",
    },
  ],
]
*/
